import Rapor from "../../../../../components/categories/siakad/lms/rapor/HomeTeacher";
export default function Home() {
  
  return (
    <Rapor />
  );
}
